<template>
  <p class="banner__text">
    If you still need to reset your password try using
    <router-link
      :to="FORGOT_PASSWORD_ROUTE.path"
      :style="{ color: 'var(--white)', textDecoration: 'underline' }"
      >Forgot password</router-link
    >
    again
  </p>
</template>

<script setup>
import { ROUTES } from "@/const";

const FORGOT_PASSWORD_ROUTE = ROUTES.get("FORGOT_PASSWORD");
</script>
